module.exports = __webpack_public_path__ + "img/table-empty.add38bbc.png";